import { forwardRef } from 'preact/compat';
import { SvgIcon, useConfigStore, useResetForm } from '@/features/form';
import { makeClassName } from '@/utils';

export default forwardRef(function RestartButton({ onAnimationEnd = () => {} }, ref) {
	const { text = {} } = useConfigStore();
	const reset = useResetForm();
	return (
		<div className={makeClassName('restart-button-wrap')}>
			<button
				ref={ref}
				type="button"
				className={makeClassName('restart-button')}
				onAnimationEnd={onAnimationEnd}
				onClick={reset}
				aria-label={text.restartButtonText ?? 'Restart'}
			>
				<SvgIcon
					icon="refresh"
					alt="refresh icon"
				/>
				{text.restartButtonText ?? 'Restart'}
			</button>
		</div>
	);
});
